import { SET_LAST_DASHBOARD } from '../actionTypes';

// begrenzt die persistierte Auswahl auf die zuletzt benutzten Aufträge
const MAX_ENTRIES = 200;

const dashboardSelection = (state = {}, action) => {
  switch (action.type) {
    case SET_LAST_DASHBOARD: {
      const newState = {
        ...state,
        [action.orderNumber]: {
          dashboardId: action.dashboardId,
          lastUsed: action.lastUsed,
        },
      };

      const keys = Object.keys(newState);
      if (keys.length > MAX_ENTRIES) {
        keys
          .sort((a, b) => newState[a].lastUsed - newState[b].lastUsed)
          .slice(0, keys.length - MAX_ENTRIES)
          .forEach((key) => delete newState[key]);
      }

      return newState;
    }
    default:
      return state;
  }
};

export default dashboardSelection;
